import { useNavigate, useSearchParams } from 'react-router-dom';
import { useState } from 'react';

export const useMemberRouting = () => {
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState('');

  const [searchParams] = useSearchParams();

  const currentParams = searchParams.get('current');

  return {
    navigate,
    currentParams,
    searchParams,
    searchQuery,
    setSearchQuery,
  };
};
